export default __webpack_public_path__ + "static/media/ast-02.8209a3cd.png";